import React from 'react';
import { Line, Pie } from 'react-chartjs-2';
import { formatUptime, prepareMessageChartData, prepareCacheChartData } from './metricsHelpers';

const OverviewTab = ({ currentMetrics, hourlyMetrics }) => {
  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
        {/* System Uptime Card */}
        <div className="bg-white rounded-lg shadow p-4">
          <h3 className="text-lg font-semibold text-gray-700 mb-2">System Uptime</h3>
          <p className="text-2xl font-bold text-blue-600">
            {currentMetrics ? formatUptime(currentMetrics.uptime_ms) : 'N/A'}
          </p>
        </div>

        {/* Messages Processed Card */}
        <div className="bg-white rounded-lg shadow p-4">
          <h3 className="text-lg font-semibold text-gray-700 mb-2">Messages Processed</h3>
          <p className="text-2xl font-bold text-blue-600">
            {currentMetrics && currentMetrics.messages_processed != null
              ? currentMetrics.messages_processed.toLocaleString()
              : 'N/A'}
          </p>
        </div>

        {/* Cache Hit Ratio Card */}
        <div className="bg-white rounded-lg shadow p-4">
          <h3 className="text-lg font-semibold text-gray-700 mb-2">Cache Hit Ratio</h3>
          <p className="text-2xl font-bold text-blue-600">
            {currentMetrics && currentMetrics.cache_hit_ratio != null
              ? `${(currentMetrics.cache_hit_ratio * 100).toFixed(1)}%`
              : 'N/A'}
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        {/* Processing Metrics */}
        <div className="bg-white rounded-lg shadow p-4">
          <h3 className="text-lg font-semibold text-gray-700 mb-4">Message Processing</h3>
          {hourlyMetrics.length > 0 ? (
            <Line
              data={prepareMessageChartData(hourlyMetrics)}
              options={{
                responsive: true,
                scales: {
                  y: {
                    beginAtZero: true
                  }
                }
              }}
            />
          ) : (
            <p className="text-gray-500 italic">No data available</p>
          )}
        </div>

        {/* Cache Summary */}
        <div className="bg-white rounded-lg shadow p-4">
          <h3 className="text-lg font-semibold text-gray-700 mb-4">Cache Performance</h3>
          {currentMetrics ? (
            <div className="flex justify-center">
              <div className="w-64">
                <Pie
                  data={prepareCacheChartData(currentMetrics)}
                  options={{
                    responsive: true,
                    plugins: {
                      legend: {
                        position: 'bottom'
                      }
                    }
                  }}
                />
              </div>
            </div>
          ) : (
            <p className="text-gray-500 italic">No data available</p>
          )}
        </div>
      </div>
    </>
  );
};

export default OverviewTab;
